<template>
  <div class="main-block">
    <div class="main-block__header">
      <h2 class="main-block__title">{{ aplication.title ? aplication.title : 'Без названия' }}</h2>
      <span class="main-block__status"
            :style="styleStatus(aplication.status)"
            >{{ aplication.status }}
        <VTooltip v-if="aplication.status === 'Не согласовано'" :text="aplication.reject_reason" autoWidth class="create-employee-main__tooltip">
            <template #icon>
                 <Tooltip icon-size="18px" />
            </template>
        </VTooltip>
      </span>
    </div>
    <div style="margin-top: 8px" class="main-block__salary">
      <VPriority :text="aplication.priority"/>
    </div>

<!--    <p v-else class="main-block__salary">{{-->
<!--        aplication?.salary_from-->
<!--            ? `${aplication?.salary_from?.toLocaleString('ru')} - ${aplication?.salary_to?.toLocaleString('ru')} ₽`-->
<!--            : 'Не указано'-->
<!--      }}</p>-->

    <VDivider />

    <div class="main-block__fields">
      <div class="main-block__fields-title">Основная информация</div>

      <div class="main-block__fields-content">
        <div class="main-block__fields-list">
          <div class="main-block__field">
            <div class="main-block__field-name">Должность</div>
            {{
              aplication?.speciality_name ? aplication.speciality_name : '-'
            }}
          </div>
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Подразделение:</div>-->
          <!--            {{-->
          <!--              aplication?.working_conditions?.department ? aplication.working_conditions.department : 'Не указано'-->
          <!--            }}-->
          <!--          </div>-->
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Регион</div>-->
          <!--            {{ aplication?.region_name ? aplication.region_name : '-' }}-->
          <!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Место работы</div>
            {{
              aplication?.place_of_work ? aplication.place_of_work : '-'
            }}
          </div>
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Условия договора</div>-->
          <!--            {{-->
          <!--              aplication?.terms_of_contract === 'OpenEnded' ? 'Бессрочный' : 'Срочный'-->
          <!--            }}-->
          <!--          </div>-->
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Срок договора</div>-->
          <!--            {{-->
          <!--              aplication?.terms_of_contract ? aplication?.terms_of_contract === 'FixedTerm' ? 'Срочный' : 'Бессрочный' : '-'-->
          <!--            }}-->
          <!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Опыт работы</div>
            {{
              aplication?.experience ? aplication.experience : '-'
            }}
          </div>
          <div v-if="!!aplication.is_fix_salary" class="main-block__field">
            <div class="main-block__field-name">Зарплата</div>
            {{
              aplication?.fix_salary ? aplication.fix_salary?.toLocaleString('ru') : '-'
            }}
          </div>
          <div v-if="!aplication.is_fix_salary" class="main-block__field">
            <div class="main-block__field-name">Зарплата</div>
            <div v-if="aplication?.salary_to && aplication?.salary_from">{{ 'от ' + aplication.salary_from?.toLocaleString('ru') + ' - до ' + aplication.salary_to?.toLocaleString('ru') }}</div>
            <div v-if="aplication?.salary_to && !aplication?.salary_from">{{'до ' +aplication.salary_to?.toLocaleString('ru') }}</div>
            <div v-if="!aplication?.salary_to && aplication?.salary_from">{{'от ' +aplication.salary_from?.toLocaleString('ru') }}</div>
          </div>
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Образование</div>-->
          <!--            {{-->
          <!--              aplication?.education_level ? aplication.education_level : '-'-->
          <!--            }}-->
          <!--          </div>-->
          <!--                    <div class="main-block__field">-->
          <!--                        <div class="main-block__field-name">Трудовые функции:</div>-->
          <!--                        {{-->
          <!--                            aplication.worker_functions_required ? 'Обязательно' : 'Необязательно'-->
          <!--                        }}-->
          <!--                    </div>-->
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">График работы</div>-->
          <!--            {{ aplication?.schedule ? aplication.schedule : '-' }}-->
          <!--          </div>-->
          <!--          <div class="main-block__field">-->
          <!--            <div class="main-block__field-name">Дорожные расходы</div>-->
          <!--            {{-->
          <!--              aplication?.include_traveling_expenses ? 'Включены' : 'Не включены'-->
          <!--            }}-->
          <!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Подразделение</div>
            {{ aplication?.division_name ? aplication.division_name : '' }}
          </div>
          <div class="main-block__field">
            <div class="main-block__field-name">Юридическое лицо</div>
            {{ aplication?.legal_entity_name ? aplication.legal_entity_name : '-' }}
          </div>
          <div class="main-block__field">
            <div class="main-block__field-name">Причина заявки</div>
            {{ aplication?.reason ? aplication.reason : '-' }}
          </div>
          <div class="main-block__field">
            <div class="main-block__field-name">Желаемая дата выхода</div>
            {{ aplication?.date_start_work ? getDate(aplication.date_start_work) : '-' }}
          </div>
        </div>
      </div>
    </div>
    <VDivider />
    <div class="main-block__description">
      <div class="main-block__description-title">Прикрепленные документы</div>

      <VAddFiles style="margin-top: 0" v-if="aplication?.documents?.length > 0" set-padding="0"  v-model="docs"
                 :valueIn="aplication?.documents" delete-btn-disabled
                 no-preview />
      <div style="margin-top: 8px" v-else>-</div>
<!--      <VAddFiles v-if="documents_for_sign_in?.length > 0" set-padding="0"  v-model="documents_for_sign_in"-->
<!--                 :valueIn="aplication?.documents_for_sign" delete-btn-disabled-->
<!--                 no-preview />-->
    </div>
    <VDivider />

    <div class="main-block__description">
      <div class="main-block__description-title">Описание вакансии</div>
      <p class="main-block__description-text" v-html="aplication?.description ? aplication.description : '-'"></p>
    </div>
  </div>
</template>

<script setup>
import moment from "moment";
import {computed, ref} from "vue";
import VDivider from "@/components/UI/VDivider/index.vue";
import VAddFiles from "@/components/UI/VAddFiles.vue";
import Tooltip from "@/components/Icons/Tooltip.vue";
import VPriority from "@/components/UI/VPriority.vue";

const props = defineProps({
  aplication: {
    type: Object,
    required: true,
  },
  actions: Object,
})

const docs = computed(() => {
  return props.aplication?.documents?.map((doc) => {
    return doc.id;
  })
})
const getDate = (date) => {
  return moment(date).format("DD.MM.YYYY");
}

const styleStatus = (status) => {
  console.log(status);
  if( status === "Отменено" ) {
    return "background-color: #DD46461A; color: #DD4646;"
  }
  if( status === "Ожидание" ) {
    return "background-color: #F4F5F7; color: #8F9CAC;"
  }
  if( status === "В работе" ) {
    return "background-color: #0962A91A; color: #0086B2;"
  }
  if( status === "Открыта" ) {
    return "background-color: #566A83; color: #FFFFFF;"
  }
  if( status === "Согласование" ) {
    return "background-color: #F4F5F7; color: #8F9CAC;"
  }
  if( status === "Не согласовано" ) {
    return "background-color: #DD46461A; color: #DD4646;"
  }
  if( status === "Выполнено" ) {
    return "background-color: #0962A91A; color: #26A659;"
  }
}

const documents_for_sign_in = ref([])

const actionTitle = computed(() => {
  if(!props.actions?.save_draft && !props.actions?.save_vacancy) {
    return 'Закрыта'
  } else {
    return props.aplication?.is_published ? 'Отказано ' : 'Черновик'
  }
})
</script>

<style scoped lang="scss">
.main-block {
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0 #0000000A;

  &__title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 20px;
    font-weight: 600;
  }

  &__salary {
    margin-top: 4px;
    font-size: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__status {
    display: flex;
    gap: 5px;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: $dark-blue;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  &__fields {
    margin-top: 24px;
  }

  &__fields-title {
    font-size: 14px;
    font-weight: 600;
  }

  &__fields-content {
    margin-top: 12px;
    display: flex;
  }

  &__fields-list {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  &__field {
    font-size: 14px;
    font-weight: 400;
    width: 200px;
  }

  &__field-name {
    white-space: nowrap;
    width: 142px;
    margin-bottom: 4px;
    color: $gray;
  }

  &__description {
    margin-top: 24px;
  }

  &__description-title {
    font-size: 14px;
    font-weight: 600;
  }

  &__description-text {
    margin-top: 12px;
    font-size: 14px;

    &::v-deep(ul) {
      margin-top: 3px;
      padding-left: 21px;

      li {
        &:not(:first-child) {
          margin-top: 3px;
        }
      }
    }

    &::v-deep(ol) {
      margin-top: 3px;
      padding-left: 20px;

      li {
        &:not(:first-child) {
          margin-top: 3px;
        }
      }
    }
  }
}
</style>
